import { MapPin, Phone, Clock, Navigation } from "lucide-react";

export default function Location() {
  return (
    <section
      id="location"
      data-testid="location-section"
      className="section border-t border-white/10"
    >
      <div className="container-x grid grid-cols-1 lg:grid-cols-12 gap-8">
        <div className="lg:col-span-5">
          <div className="text-[11px] tracking-[0.3em] uppercase text-[#FF3B30] mb-4">
            / 05 — Come train
          </div>
          <h2
            data-testid="location-title"
            className="font-display text-5xl md:text-6xl uppercase leading-[0.95] tracking-tight"
          >
            Caldwell,
            <br />
            Idaho.
          </h2>
          <p className="text-white/70 mt-6 text-lg leading-relaxed max-w-md">
            Train in person with Coach Manny, or work with him from anywhere
            through online coaching.
          </p>

          <div className="mt-10 space-y-6">
            <div className="flex gap-4">
              <span className="w-10 h-10 border border-white/15 flex items-center justify-center shrink-0">
                <MapPin size={16} className="text-[#FF3B30]" />
              </span>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
                  Address
                </div>
                <div className="text-white mt-1">
                  16875 Live Oak Pl, Caldwell, ID 83607
                </div>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="w-10 h-10 border border-white/15 flex items-center justify-center shrink-0">
                <Phone size={16} className="text-[#FF3B30]" />
              </span>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
                  Phone
                </div>
                <a
                  href="tel:+12089019386"
                  data-testid="location-phone"
                  className="text-white mt-1 hover:text-[#FF3B30] block"
                >
                  (208) 901-9386
                </a>
              </div>
            </div>
            <div className="flex gap-4">
              <span className="w-10 h-10 border border-white/15 flex items-center justify-center shrink-0">
                <Clock size={16} className="text-[#FF3B30]" />
              </span>
              <div>
                <div className="text-[10px] tracking-[0.3em] uppercase text-white/50">
                  Availability
                </div>
                <div className="text-white mt-1">
                  Flexible sessions · Online 24/7
                </div>
              </div>
            </div>
          </div>

          <a
            href="https://www.google.com/maps/search/?api=1&query=16875+Live+Oak+Pl+Caldwell+ID+83607"
            target="_blank"
            rel="noreferrer"
            data-testid="location-directions"
            className="btn-primary mt-10"
          >
            <Navigation size={16} /> Get Directions
          </a>
        </div>

        <div className="lg:col-span-7">
          <div className="relative w-full aspect-[4/3] md:aspect-[16/10] border border-white/10 overflow-hidden">
            <iframe
              title="Meño Coaching location"
              data-testid="location-map"
              src="https://www.google.com/maps?q=16875+Live+Oak+Pl,+Caldwell,+ID+83607&output=embed"
              className="absolute inset-0 w-full h-full"
              style={{ filter: "grayscale(0.6) invert(0.92) hue-rotate(180deg)" }}
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
